
module.exports = {
    Address: require("./src/address"),
    Aes: require("./src/aes"),
    PrivateKey: require("./src/key_private"),
    PublicKey: require("./src/key_public"),
    Signature: require("./src/signature"),
    brainKey: require("./src/brain_key"),
    key_utils: require("./src/key_utils"),
    hash: require("./src/hash"),
    ecc_config: require("../../config")
}



// WEBPACK FOOTER //
// ./src/auth/ecc/index.js